import { useEffect, useState } from 'react';

import { SECURE_API } from 'src/api/api';
import {
  SignupBreakdownItem,
  SignupBreakdownResponse,
} from 'src/interfaces/SignupBreakdown';

interface UseSignupBreakdownParams {
  editionId?: string | null;
  /** When false, skip fetch. */
  enabled?: boolean;
}

interface UseSignupBreakdownResult {
  items: SignupBreakdownItem[];
  isLoading: boolean;
  error: string | null;
}

export function useSignupBreakdown({
  editionId,
  enabled = true,
}: UseSignupBreakdownParams): UseSignupBreakdownResult {
  const [items, setItems] = useState<SignupBreakdownItem[]>([]);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    if (!enabled || !editionId) {
      setItems([]);
      setError(null);
      setIsLoading(false);
      return;
    }

    let cancelled = false;
    setIsLoading(true);
    setError(null);

    SECURE_API.get<SignupBreakdownResponse>('registrations/signup-breakdown', {
      params: { editionId },
    })
      .then(({ data }) => {
        if (!cancelled) {
          setItems(data.items ?? []);
        }
      })
      .catch(() => {
        if (!cancelled) {
          setItems([]);
          setError('fetch');
        }
      })
      .finally(() => {
        if (!cancelled) {
          setIsLoading(false);
        }
      });

    return () => {
      cancelled = true;
    };
  }, [enabled, editionId]);

  return { items, isLoading, error };
}
